'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var scrollElement = require('scroll-element');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var sidePanel = require('./side-panel');

var selectedItemClass = 'main-nav__sub-menu-item--is-selected';
var dom;

var getSelectedItem = function() {

	return appDom.mainNav.find('.' + selectedItemClass);

};

var getItemByIndex = function(index) {

	return appDom.mainNav.find('[data-gallery-index="' + index + '"]');

};

// Allow $item to be passed in, since in some cases we will already have it
// to perform other logic.
var unselect = function($item) {

	$item = $item || getSelectedItem();

	$item.removeClass(selectedItemClass);

};

var select = function($item) {

	$item.addClass(selectedItemClass);

};

var updateSelection = function() {

	var $oldGallery = getSelectedItem();
	var $newGallery = getItemByIndex(dataMgr.getGalleryIndex());

	// Avoid toggling the same gallery if user went back/forward from a
	// slideshow.
	if (!$oldGallery.is($newGallery)) {

		// Turn off old highlight.
		unselect($oldGallery);

		// Turn on new highlight.
		select($newGallery);

	}

};

var updateFavoriteCount = function(count) {

	appDom.mainNavFavoriteCount.text(count);

};

var toggleMusicDisplay = function(status) {

	var $musicCommandText = appDom.sidePanel.find('.main-nav__music-command-text');

	$musicCommandText.text($musicCommandText.attr('data-' + status));

};

var addEventHandlers = function() {

	appDom.document.on('gallery_data_ready', updateSelection);

	appDom.document.on('music_paused music_played', function(e) {

		if (e.type === 'music_paused') {

			toggleMusicDisplay('pause');

		} else {

			toggleMusicDisplay('play');

		}

	});

	// if (appDom.isTouch()) {

	// 	appDom.document.on('selected_gallery_list_item_clicked', function() {

	// 		appDom.sidePanel.one('-webkit-transitionend transitionend', function() {

	// 			scrollElement({
	// 				container: appDom.sidePanel,
	// 				scrollTop: appDom.sidePanel.find('.main-nav__menu').position().top
	// 			});

	// 		});

	// 		sidePanel.open(dom.mainNav.html());

	// 	});

	// }

	appDom.document.on('click', '.main-nav__menu-trigger', function(e) {

		sidePanel.open(dom.mainNav.html());

		triggerCustomEvent('main_nav_opened');

		e.preventDefault();

	});

	appDom.document.on('comment_count_updated', function(e, data) {

		appDom.mainNavCommentCount.text(data.response.count);

	});

	appDom.document.on('favorite_count_updated', function(e, data) {

		updateFavoriteCount(data.count);

	});

	appDom.document.on('contact_login_success contact_login_account_creation_success', function(e, data) {

		appDom.mainNavLogout.removeClass('main-nav__menu-link--hidden');
		appDom.mainNavContactEmail.text('(' + data.response.email + ')');

	});

	appDom.document.on('click', '.main-nav__sub-menu-item:not(.' + selectedItemClass + ')', function() {

		var $this = $(this);
		var galleryIndex = parseInt($this.attr('data-gallery-index'), 10);

		// Broadcast the new selected gallery.
		triggerCustomEvent('main_nav_gallery_selected', {
			data: {
				galleryIndex: galleryIndex
			}
		});

	});

	appDom.document.on('click', '.main-nav__menu-item--share', function(){

		triggerCustomEvent('main_nav_share_clicked');

	});

	appDom.document.on('click', '.main-nav__menu-item--comments', function(){

		triggerCustomEvent('main_nav_comments_clicked');

	});

	appDom.document.on('click', '.main-nav__menu-item--favorites', function(){

		triggerCustomEvent('main_nav_send_favorites_clicked');

	});

	appDom.document.on('click', '.main-nav__menu-item--music', function(){

		triggerCustomEvent('main_nav_music_clicked');

	});

};

var setupDom = function() {

	dom = {};
	dom.mainNav = $('.main-nav');

};

var init = function() {

	setupDom();
	addEventHandlers();

};

module.exports = {
	init: init
};
